//end iffe to pass to pass in jquery and ht namespace
})(jQuery, ht);